import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { useEffect } from 'preact/hooks';
import { useAuth } from '../auth/useAuth';
import { useLocation } from 'preact-iso';
export function ProtectedRoute({ children }) {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();
    useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            // Save current URL for redirect after login
            localStorage.setItem('orbitalx-redirect-after-login', location.url);
            // Redirect to login page if not authenticated
            location.route('/login');
        }
    }, [isAuthenticated, isLoading, location]);
    // Show loading while checking authentication
    if (isLoading) {
        return (_jsx("div", { className: "min-h-screen bg-slate-50 dark:bg-slate-900 flex items-center justify-center", children: _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600 mb-4" }), _jsx("p", { className: "text-lg text-slate-600 dark:text-slate-300", children: "Loading..." })] }) }));
    }
    // Don't render children if not authenticated
    if (!isAuthenticated) {
        return null;
    }
    return _jsx(_Fragment, { children: children });
}
